import { useContext, useEffect, useState } from "react";
import { FieldErrors, UseFormGetValues, UseFormSetValue, UseFormTrigger } from "react-hook-form";

import useFetch from "../useFetch";
import { LoaderContext } from "src/context/loaderContext";
import { ToastContext } from "src/context/toastContext";

import { ToastTypes } from "src/types";
import { NPILookupResponse } from "./types";
import { APIEndpoints } from "src/types/apiTypes";
import { AddProviderForm } from "src/pages/addProvider/types";



const useNPILookup = (setValue: UseFormSetValue<AddProviderForm>, trigger: UseFormTrigger<AddProviderForm>) => {
  const [preservedNpi, updatePreservedNpi] = useState<string>("");

  const { showToast } = useContext(ToastContext)
  const { setLoader, hideLoader } = useContext(LoaderContext)


  const { mutate: lookupNpi, error: npiLookupError, data: npiLookupResponse, removeErrorAndData: clearNpiResponse } =
    useFetch<NPILookupResponse>(APIEndpoints.NPI_LOOKUP);

  /**
   * Checking for NPILookup call errors
   * @NPILookUpResponseHandler
   */
  useEffect(() => {
    if (npiLookupError)
      hideLoader();

    if (npiLookupResponse) {
      if (npiLookupResponse.doctor_data) {
        hideLoader();
        const { basic, taxonomy_data } = npiLookupResponse.doctor_data;
        setValue("ref_taxonomy_id", taxonomy_data.code);
        setValue("sln", taxonomy_data.license || "");
        setValue("firstname", basic.first_name);
        setValue("lastname", basic.last_name);
        setValue("tax_id", basic.tax_id || "");
        trigger();
        showToast(["Doctor data found"], ToastTypes.INFO);
      } else {
        hideLoader();
        setValue("ref_taxonomy_id", "");
        setValue("sln", "");
        setValue("firstname", "");
        setValue("lastname", "");
        setValue("tax_id", "");
        showToast([`No Data Found`], ToastTypes.ERROR);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [npiLookupResponse, npiLookupError]);

  /**
   * When we enter after entering NPI in the input field
   * @param event
   */
  const callNPILookup = (errors: FieldErrors<AddProviderForm>, getValues: UseFormGetValues<AddProviderForm>) => {
    const npi = getValues("npi");

    if (!npi || ( npi && npi.length === 0 ) || errors.npi)
      showToast([`Please enter valid NPI for lookup`], ToastTypes.ERROR);
    else {
      if (preservedNpi !== npi) {
        updatePreservedNpi(npi || "");
        clearNpiResponse();
        setLoader();
        const data = {
          'global_doctor[npi]': npi,
        };
        lookupNpi( null, null, data );
      }
    }
  };

  return { callNPILookup }
}

export default useNPILookup
